import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateTheme } from "../hooks";
import { ThemeForm } from "../components";

export const CreateTheme: React.FC = () => {
  const navigate = useNavigate();

  const { form, submit, loading } = useCreateTheme({
    defaultValues: {},
    onCompleted: () => {
      toast.success("Le thème a été créé avec succès");
      navigate("/themes");
    },
  });

  return (
    <>
      <Header
        title="Thème"
        subtitle="Créer un nouveau thème"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/themes`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau thème" />
          <ThemeForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
